class Easie {

    backIn(time, begin, change, duration, overshoot) {
        if (overshoot === null) {
            overshoot = 1.70158;
        }
        return change * (time /= duration) * time * ((overshoot + 1) * time - overshoot) + begin;
    };
    
    // ________________________________________________________________________-

    backOut(time, begin, change, duration, overshoot) {
        if (overshoot === null) {
            overshoot = 1.70158;
        }
        return change * ((time = time / duration - 1) * time * ((overshoot + 1) * time + overshoot) + 1) + begin;
    };
    
    // ________________________________________________________________________-

    backInOut(time, begin, change, duration, overshoot) {
        if (overshoot === null) {
            overshoot = 1.70158;
        }
        if ((time = time / (duration / 2)) < 1) {
            return change / 2 * (time * time * (((overshoot *= 1.525) + 1) * time - overshoot)) + begin;
        } else {
            return change / 2 * ((time -= 2) * time * (((overshoot *= 1.525) + 1) * time + overshoot) + 2) + begin;
        }
    };
    
    // ________________________________________________________________________-

    bounceOut(time, begin, change, duration) {
        if ((time /= duration) < 1 / 2.75) {
            return change * (7.5625 * time * time) + begin;
        } else if (time < 2 / 2.75) {
            return change * (7.5625 * (time -= 1.5 / 2.75) * time + 0.75) + begin;
        } else if (time < 2.5 / 2.75) {
            return change * (7.5625 * (time -= 2.25 / 2.75) * time + 0.9375) + begin;
        } else {
            return change * (7.5625 * (time -= 2.625 / 2.75) * time + 0.984375) + begin;
        }
    };

    // ________________________________________________________________________-

    bounceIn(time, begin, change, duration) {
        return change - Easie.bounceOut(duration - time, 0, change, duration) + begin;
    };
    
    // ________________________________________________________________________-

    bounceInOut(time, begin, change, duration) {
        if (time < duration / 2) {
            return Easie.bounceIn(time * 2, 0, change, duration) * 0.5 + begin;
        } else {
            return Easie.bounceOut(time * 2 - duration, 0, change, duration) * 0.5 + change * 0.5 + begin;
        }
    };
    
    // ________________________________________________________________________-

    circIn(time, begin, change, duration) {
        return -change * (Math.sqrt(1 - (time = time / duration) * time) - 1) + begin;
    };
    
    // ________________________________________________________________________-

    circOut(time, begin, change, duration) {
        return change * Math.sqrt(1 - (time = time / duration - 1) * time) + begin;
    };

    // ________________________________________________________________________-

    circInOut(time, begin, change, duration) {
        if ((time = time / (duration / 2)) < 1) {
            return -change / 2 * (Math.sqrt(1 - time * time) - 1) + begin;
        } else {
            return change / 2 * (Math.sqrt(1 - (time -= 2) * time) + 1) + begin;
        }
    };
    
    // ________________________________________________________________________-

    cubicIn(time, begin, change, duration) {
        return change * (time /= duration) * time * time + begin;
    };
    
    // ________________________________________________________________________-

    cubicOut(time, begin, change, duration) {
        return change * ((time = time / duration - 1) * time * time + 1) + begin;
    };
    
    // ________________________________________________________________________-

    cubicInOut(time, begin, change, duration) {
        if ((time = time / (duration / 2)) < 1) {
            return change / 2 * time * time * time + begin;
        } else {
            return change / 2 * ((time -= 2) * time * time + 2) + begin;
        }
    };
    
    // ________________________________________________________________________-

    elasticOut(time, begin, change, duration, amplitude, period) {
        var overshoot;
        if (amplitude === null) {
            amplitude = null;
        }
        if (period === null) {
            period = null;
        }
        if (time === 0) {
            return begin;
        } else if ((time = time / duration) === 1) {
            return begin + change;
        } else {
            if (!(period != null)) {
                period = duration * 0.3;
            }
            if (!(amplitude != null) || amplitude < Math.abs(change)) {
                amplitude = change;
                overshoot = period / 4;
            } else {
                overshoot = period / (2 * Math.PI) * Math.asin(change / amplitude);
            }
            return (amplitude * Math.pow(2, -10 * time)) * Math.sin((time * duration - overshoot) * (2 * Math.PI) / period) + change + begin;
        }
    };
    
    // ________________________________________________________________________-

    elasticIn(time, begin, change, duration, amplitude, period) {
        var overshoot;
        if (amplitude === null) {
            amplitude = null;
        }
        if (period === null) {
            period = null;
        }
        if (time ===  0) {
            return begin;
        } else if ((time = time / duration) ===  1) {
            return begin + change;
        } else {
            if (!(period != null)) {
                period = duration * 0.3;
            }
            if (!(amplitude != null) || amplitude < Math.abs(change)) {
                amplitude = change;
                overshoot = period / 4;
            } else {
                overshoot = period / (2 * Math.PI) * Math.asin(change / amplitude);
            }
            time -= 1;
            return -(amplitude * Math.pow(2, 10 * time)) * Math.sin((time * duration - overshoot) * (2 * Math.PI) / period) + begin;
        }
    };
    
    // ________________________________________________________________________-

    elasticInOut(time, begin, change, duration, amplitude, period) {
        var overshoot;
        if (amplitude === null) {
            amplitude = null;
        }
        if (period === null) {
            period = null;
        }
        if (time ===  0) {
            return begin;
        } else if ((time = time / (duration / 2)) ===  2) {
            return begin + change;
        } else {
            if (!(period != null)) {
                period = duration * (0.3 * 1.5);
            }
            if (!(amplitude != null) || amplitude < Math.abs(change)) {
                amplitude = change;
                overshoot = period / 4;
            } else {
                overshoot = period / (2 * Math.PI) * Math.asin(change / amplitude);
            }
            if (time < 1) {
                return -0.5 * (amplitude * Math.pow(2, 10 * (time -= 1))) * Math.sin((time * duration - overshoot) * ((2 * Math.PI) / period)) + begin;
            } else {
                return amplitude * Math.pow(2, -10 * (time -= 1)) * Math.sin((time * duration - overshoot) * (2 * Math.PI) / period) + change + begin;
            }
        }
    };
    
    // ________________________________________________________________________-

    expoIn(time, begin, change, duration) {
        if (time ===  0) {
            return begin;
        }
        return change * Math.pow(2, 10 * (time / duration - 1)) + begin;
    };
    
    // ________________________________________________________________________-

    expoOut(time, begin, change, duration) {
        if (time ===  duration) {
            return begin + change;
        }
        return change * (-Math.pow(2, -10 * time / duration) + 1) + begin;
    };
    
    // ________________________________________________________________________-

    expoInOut(time, begin, change, duration) {
        if (time ===  0) {
            return begin;
        } else if (time ===  duration) {
            return begin + change;
        } else if ((time = time / (duration / 2)) < 1) {
            return change / 2 * Math.pow(2, 10 * (time - 1)) + begin;
        } else {
            return change / 2 * (-Math.pow(2, -10 * (time - 1)) + 2) + begin;
        }
    };
    
    // ________________________________________________________________________-

    linearNone(time, begin, change, duration) {
        return change * time / duration + begin;
    };
    
    // ________________________________________________________________________-

    linearIn(time, begin, change, duration) {
        return Easie.linearNone(time, begin, change, duration);
    };
    
    // ________________________________________________________________________-

            linearOut(time, begin, change, duration) {
        return Easie.linearNone(time, begin, change, duration);
    };
    
    // ________________________________________________________________________-

    linearInOut(time, begin, change, duration) {
        return Easie.linearNone(time, begin, change, duration);
    };
    
    // ________________________________________________________________________-

    quadIn(time, begin, change, duration) {
        return change * (time = time / duration) * time + begin;
    };
    
    // ________________________________________________________________________-

    quadOut(time, begin, change, duration) {
        return -change * (time = time / duration) * (time - 2) + begin;
    };
    
    // ________________________________________________________________________-

    quadInOut(time, begin, change, duration) {
        if ((time = time / (duration / 2)) < 1) {
            return change / 2 * time * time + begin;
        } else {
            return -change / 2 * ((time -= 1) * (time - 2) - 1) + begin;
        }
    };
    
    // ________________________________________________________________________-

    quartIn(time, begin, change, duration) {
        return change * (time = time / duration) * time * time * time + begin;
    };
    
    // ________________________________________________________________________-

    quartOut(time, begin, change, duration) {
        return -change * ((time = time / duration - 1) * time * time * time - 1) + begin;
    };
    
    // ________________________________________________________________________-

    quartInOut(time, begin, change, duration) {
        if ((time = time / (duration / 2)) < 1) {
            return change / 2 * time * time * time * time + begin;
        } else {
            return -change / 2 * ((time -= 2) * time * time * time - 2) + begin;
        }
    };
    
    // ________________________________________________________________________-

    quintIn(time, begin, change, duration) {
        return change * (time = time / duration) * time * time * time * time + begin;
    };
    
    // ________________________________________________________________________-

    quintOut(time, begin, change, duration) {
        return change * ((time = time / duration - 1) * time * time * time * time + 1) + begin;
    };
    
    // ________________________________________________________________________-

    quintInOut(time, begin, change, duration) {
        if ((time = time / (duration / 2)) < 1) {
            return change / 2 * time * time * time * time * time + begin;
        } else {
            return change / 2 * ((time -= 2) * time * time * time * time + 2) + begin;
        }
    };

    // ________________________________________________________________________-

    sineIn(time, begin, change, duration) {
        return -change * Math.cos(time / duration * (Math.PI / 2)) + change + begin;
    };
    
    // ________________________________________________________________________-

    sineOut(time, begin, change, duration) {
        return change * Math.sin(time / duration * (Math.PI / 2)) + begin;
    };

    // ________________________________________________________________________-

    sineInOut(time, begin, change, duration) {
        return -change / 2 * (Math.cos(Math.PI * time / duration) - 1) + begin;
    };
} 

// export
export default new Easie();